<template>
    <v-list-item>
      <template #prepend>
        <v-avatar>
          <v-img :src="playerScore.player.pictureUrl" :alt="playerScore.player.name" />
        </v-avatar>
      </template>
      <v-list-item-title>
        {{ playerScore.player.name }}
        <score
          :score="playerScore.totalScore"
        />
      </v-list-item-title>
    </v-list-item>
</template>


<script>
import Score from '@/components/Card/Score.vue';
import ModelPlayerScore from '@/models/PlayerScore/playerScore';

export default {
  name: 'PlayerScore',
  components: {
    Score,
  },
  props: {
    playerScore: {
      type: ModelPlayerScore,
      required: true,
    },
  },
}
</script>
